<template>
    <div class="page courses-page py-lg-6">
        <v-container :class="{'white px-0': phoneOnly}">
            <v-row :class="{'mx-0': phoneOnly}">
                <v-col cols="12" lg="3" :class="{'px-4 pt-5 pb-0': phoneOnly}">
                    <div :style="pcOnly ? 'position: sticky; top: 100px;' : ''">
                        <form @submit.prevent="search">
                            <v-text-field v-model="searchQuery" :solo="phoneOnly" :flat="phoneOnly" ref="searchInput" label="Search in courses" placeholder="Enter course name.." :prepend-inner-icon="pcOnly ? 'mdi-magnify' : ''" :append-icon="phoneOnly ? 'mdi-magnify' : ''" :outlined="pcOnly" :dense="pcOnly" clearable class="mb-lg-4 mb-3" :class="{'course-input': phoneOnly}" hide-details ></v-text-field>
                        </form>
                        <div v-if="pcOnly" >
                            <v-card class="bordered mb-5" style="border-radius: 10px!important;">
                                <div class="header px-4 py-2">
                                    <span class="details-text strong-text--text">Packages</span>
                                </div>
                                <v-divider class="mb-2"></v-divider>
                                <v-list dense class="pt-0">
                                    <v-list-item v-for="grade in grades" small dense :key="grade.id" class="px-6" @click="selectedGrade =  grade.id; selectedCategory = '';" :class="{'v-list-item--active': selectedGrade === grade.id}" style="height: auto!important; min-height: unset!important" v-ripple="phoneOnly">
                                        <v-list-item-icon class="me-3">
                                            <v-icon size="18" :color="selectedGrade === grade.id ? 'primary' : 'text'">mdi-school{{selectedGrade !== grade.id ? '-outline' : ''}}</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title style="font-size: 14px">{{grade.name}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-card>
                            <v-card class="bordered mb-3" style="border-radius: 10px!important;">
                                <div class="header px-4 py-2">
                                    <span class="details-text strong-text--text">Categories</span>
                                </div>
                                <v-divider class="mb-2"></v-divider>
                                <v-list dense class="pt-0">
                                    <v-list-item v-for="category in categories" :key="category.id" class="px-6" @click="selectedCategory =  category.id; selectedGrade = '';" :class="{'v-list-item--active': selectedCategory === category.id}" v-ripple="phoneOnly">
                                        <v-list-item-icon class="me-3">
                                            <v-icon size="16" :color="selectedCategory === category.id ? 'primary' : 'text'">mdi-book{{selectedCategory !== category.id ? '-outline' : ''}}</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title style="font-size: 14px">{{category.name}}</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-card>
                        </div>
                        <div v-else>
                            <v-select v-model="selectedGrade" solo flat clearable :items="gradesItems" label="Package" placeholder="Choose Package" hide-details class=" mb-3" :class="{'course-input': phoneOnly}"></v-select>
                            <v-select v-model="selectedCategory" solo flat clearable :items="categoriesItems" label="Category" placeholder="Choose category" hide-details class="mb-4" :class="{'course-input': phoneOnly}"></v-select>
                        </div>

                        <v-btn v-if="pcOnly" text block @click="resetFilters" :disabled="!selectedGrade && !selectedCategory && !searchQuery">
                            <v-icon left>mdi-filter-remove-outline</v-icon>
                            Reset Filters
                        </v-btn>
                    </div>
                </v-col>
                <v-col cols="12" lg="9" :class="{'pa-0': phoneOnly}">
                    <v-card class="pa-0 transparent" flat>
                        <!-- <v-card-subtitle>قائمة الدورات التعليمية المتاحة للانضمام إليها</v-card-subtitle> -->
                        <v-card-text class="py-lg-2" :class="{'pa-0': phoneOnly}">
                            <transition name="fade-transition" mode="out-in">
                                <template v-if="!loading || loadedOnce">
                                    <infinity-wrapper v-if="courses && courses.length" @load="getCourses(false)" key="courses">
                                        <v-row v-if="pcOnly">
                                            <v-col cols="12" md="6" lg="4" v-for="(course, i) in courses" :key="course.id + '-' + i" class="px-0 px-md-2 py-2">
                                                <course-card :course="course"> </course-card>
                                            </v-col>
                                        </v-row>
                                        <v-list v-else two-line class="px-0">
                                            <course-list-item v-for="(course, i) in courses" :key="course.id + '-' + i" :course="course" />
                                        </v-list>
                                    </infinity-wrapper>
                                    <div v-else class="pa-4 pa-lg-0">
                                        <v-alert color="blue-grey" text type="info">No courses found</v-alert>
                                    </div>
                                </template>
                                <template v-else>
                                    <v-row key="loading">
                                        <v-col cols="12" md="6" lg="4" v-for="i in 6" :key="'loading-' + i" class="px-4 py-2 mb-2">
                                            <v-skeleton-loader v-if="pcOnly" class="bordered" type="image, list-item-three-line, list-item-three-line" ></v-skeleton-loader>
                                            <v-skeleton-loader v-else type="list-item-three-line" class="bordered py-0" ></v-skeleton-loader>
                                        </v-col>
                                    </v-row>
                                </template>
                            </transition>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import InfinityWrapper from '@/components/default/infinity-wrapper'
import CourseCard from '@/components/custom/course-card'
import CourseListItem from '@/components/custom/course-list-item'

export default {
    name: "Courses",
    components: {
        InfinityWrapper,
        CourseCard,
        CourseListItem
    },
    data(){
        return {
            searchQuery: '',
            selectedCategory: '',
            selectedGrade: '',

            loading: true,
            loadedOnce: false,
        }
    },
    computed: {
        ...GlobalComputed,
        courses(){
            return this.$store.state.coursesModule.courses;
        },
        categories(){
            return this.appData.categories;
        },
        grades(){
            return this.appData.grades;
        },
        categoriesItems(){
            return this.categories.map(category=>{
                return {text: category.name, value: category.id};
            });
        },
        gradesItems(){
            return this.grades.map(grade=>{
                return {text: grade.name, value: grade.id};
            });
        },
    },
    watch: {
        selectedCategory(category){
            if ((category && !this.selectedGrade) || (!category && this.phoneOnly)){
                this.getCourses(true);
            }
        },
        selectedGrade(grade){
            if ((grade && !this.selectedCategory) || (!grade && this.phoneOnly)){
                this.getCourses(true);
            }
        },
        searchQuery(query){
            if (!query){
                this.getCourses(true);
                this.updateSearchUrlQuery('');
            }
        },

        $route: {
            deep: true,
            handler($route){
                if ($route.query.search !== this.searchQuery){
                    this.searchQuery = $route.query.search;
                    this.search();
                }
            }
        }
    },
    methods: {
        search(){
            this.getCourses(true);
            this.updateSearchUrlQuery(this.searchQuery);
        },
        resetFilters(){
            this.selectedGrade = '';
            this.selectedCategory = '';
            if (this.searchQuery){
                this.searchQuery = '';
            }else{
                this.getCourses(true);
            }
        },
        getCourses(initialLoad = false){
            if (!this.loading || initialLoad){
                this.loading = true;
                
                if (initialLoad){
                    this.setLinearLoading();
                }
                let data = {};
                if (this.searchQuery){
                    data.query = this.searchQuery;
                }
                if (this.selectedCategory){
                    data.category_id = this.selectedCategory;
                }else if (this.selectedGrade){
                    data.grade_id = this.selectedGrade;
                }

                this.$store.dispatch('getCourses', {initialLoad, data}).then(()=>{
                    if (initialLoad){
                        this.setLinearLoading(false);
                        this.loadedOnce = true;
                    }
                    this.loading = false;
                    this.$refs.searchInput.blur();

                }).catch(()=>{
                    if (initialLoad){
                        this.setLinearLoading(false);
                    }
                    if (this.$route.name === 'courses'){
                        this.showMsg('حدثت مشكلة أثناء تحميل الدورات');
                    }
                    this.loading = false;
                });
            }
        },
        updateSearchUrlQuery(search){
            let query = search ? '?search='+search : '?';
            window.history.replaceState(null, null, query);
        },
        ...GlobalMethods,
    },
    mounted(){
        if (this.$route.query.search){
            this.searchQuery = this.$route.query.search;
        }
        this.getCourses(true);
        this.scrollToTop();

        /* if (!this.courses || this.courses.length === 0){
            this.getCourses(true);
        }else{
            this.loading = false;
        } */
    }
};
</script>

<style lang="scss">
.course-input{
    // background: ;
    .v-input__slot{
        background-color: #f3f3f3!important;
    }
}
.v-skeleton-loader__image{
    height: 150px!important;
}
</style>